import { camelCase, forEach, get, isArray, isString } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { Model } from '@stratusjs/angularjs/services/model';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'property';
const componentName = 'details-sub-section';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
Stratus.Components.IdxPropertyDetailsSubSection = {
    bindings: {
        ngModel: '=',
        items: '@',
        sectionName: '@',
        className: '@',
        template: '@',
    },
    controller($attrs, $scope) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        $scope.className = $attrs.className || 'sub-detail-section';
        $scope.sectionName = $attrs.sectionName || '';
        $scope.sectionNameId = camelCase($scope.sectionName) + '_' + $scope.elementId;
        const defaultItems = {};
        $scope.items = $attrs.items && isJSON($attrs.items) ? JSON.parse($attrs.items) : defaultItems;
        $scope.visibleFields = false;
        $scope.model = null;
        const checkForVisibleFields = () => {
            Object.keys($scope.items).forEach((item) => {
                if (Object.prototype.hasOwnProperty.call($scope.model.data, item) &&
                    $scope.model.data[item] !== 0 &&
                    $scope.model.data[item] !== '' &&
                    $scope.model.data[item] !== '0' &&
                    !isString($scope.items[item])) {
                    if (!($scope.model.data[item] === false &&
                        get($scope.items[item], 'false') === '')) {
                        if (Object.prototype.hasOwnProperty.call($scope.items[item], 'appendField') &&
                            Object.prototype.hasOwnProperty.call($scope.model.data, $scope.items[item].appendField) &&
                            $scope.model.data[$scope.items[item].appendField] !== '') {
                            $scope.items[item].append =
                                ' ' + $scope.model.data[$scope.items[item].appendField];
                        }
                        else if (Object.prototype.hasOwnProperty.call($scope.items[item], 'appendFieldBackup') &&
                            Object.prototype.hasOwnProperty.call($scope.model.data, $scope.items[item].appendFieldBackup) &&
                            $scope.model.data[$scope.items[item].appendFieldBackup] !== '') {
                            $scope.items[item].append =
                                ' ' + $scope.model.data[$scope.items[item].appendFieldBackup];
                        }
                        if (get($scope.items[item], 'hideEmpty') !== false &&
                            (isArray($scope.model.data[item]) && $scope.model.data[item].length <= 0)) {
                            $scope.items[item].hide = true;
                        }
                        else {
                            $scope.visibleFields = true;
                        }
                    }
                    else if ($scope.model.data[item] === false &&
                        get($scope.items[item], 'hideEmpty') !== false) {
                        $scope.items[item].hide = true;
                    }
                }
            });
        };
        if ($scope.sectionName.startsWith('{')) {
            const stopWatchingSectionName = $scope.$watch('$ctrl.sectionName', (data) => {
                $scope.sectionName = data;
                $scope.sectionNameId = camelCase($scope.sectionName) + '_' + $scope.elementId;
                stopWatchingSectionName();
            });
        }
        if (Object.keys($scope.items).length === 0) {
            const stopWatchingItems = $scope.$watch('$ctrl.items', (data) => {
                if (Object.keys($scope.items).length === 0) {
                    const blankItems = {};
                    $scope.items = data && isJSON(data) ? JSON.parse(data) : blankItems;
                    $scope.convertItemsToObject();
                }
                stopWatchingItems();
            });
        }
        const stopWatchingModel = $scope.$watch('$ctrl.ngModel', (data) => {
            if (data instanceof Model && data !== $scope.model) {
                $scope.model = data;
                checkForVisibleFields();
                stopWatchingModel();
            }
        });
        this.$onInit = () => {
            $scope.convertItemsToObject();
        };
        $scope.convertItemsToObject = () => {
            forEach($scope.items, (itemValue, itemKey) => {
                if (typeof itemValue === 'string') {
                    $scope.items[itemKey] = {
                        name: itemValue
                    };
                }
            });
        };
        $scope.typeOf = (item) => isArray(item) ? 'array' : typeof item;
        $scope.isArray = (item) => isArray(item);
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=details-sub-section.component.js.map
